// src/app/page.tsx
import { FC } from "react";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "./index.css";

const Costs: FC = () => {
  return (
    <div className="costs-section">
      <Typography component="div">Costs</Typography>
      <Grid container className="costs-container">
        <Grid size={{ xs: 12, md: 12 }}>
          <div className="per-cost">
            <Grid container sx={{ width: "100%" }}>
              <Grid size={{ xs: 6, md: 6 }}>Per Chat</Grid>
              <Grid size={{ xs: 6, md: 6 }} textAlign={"end"}>
                $0.7
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <div className="per-cost">
            <Grid container sx={{ width: "100%" }}>
              <Grid size={{ xs: 8, md: 6 }}>Per Memory Change</Grid>
              <Grid size={{ xs: 4, md: 6 }} textAlign={"end"}>
                $0.7
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <div className="per-cost-automation">
            <Grid container sx={{ width: "100%" }}>
              <Grid size={{ xs: 6, md: 6 }}>Per Automation</Grid>
              <Grid size={{ xs: 6, md: 6 }} textAlign={"end"}>
                $0.7
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Costs;
